import { createCrewLookupSelect } from './createCrewLookupSelect';

export const SexTypeSelect = createCrewLookupSelect('SexTypeSelect', 'sexTypes');
export default SexTypeSelect;
